<template>
  <div class="login-wrap">
    <input type="text"
           class="txt"
           placeholder="아이디"
           maxlength="20"
           style="width:100%;"
           @input="mberId = mberId.replace(/\s+/g, '')"
           v-model="mberId"/>
    <input type="password"
           class="txt"
           maxlength="100"
           placeholder="패스워드"
           v-model="mberPswd"
           style="width:100%;"
           @input="mberPswd = mberPswd.replace(/\s+/g, '')"
           @keyup.enter="lgin_click"/>
    <btn :txt="'로그인'"
         :size="'big'"
         :color="isInputIdPswd? 'purple': 'gray'"
         @click="lgin_click"/>
    <div class="flex-row-auto mgt10">
      <div>
        <div class="form-all">
          <input type="checkbox"
                 id="isSaveId"
                 v-model="isSaveId">
          <label for="isSaveId">
            <span class="box"></span>
            <span class="label-txt">아이디 저장</span>
          </label>
        </div>
      </div>
      <div>
        <a href="javascript:;"
           @click="txtIdPswdFind_click">
          <span>아이디ㆍ비밀번호 찾기</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, onMounted, ref, defineEmits} from 'vue';
import {getStore, getUtils} from "@/utils/import";
import IdPswdFind from "@/views/lgin/id-pswd-find.vue";
import MberFcltyNvtns from "@/views/my-home/mber-fclty-nvtns.vue";

const {$alert, $axios, $popup, $cmmn} = getUtils();
const {$mber, $loading} = getStore();

const mberId = ref('');
const mberPswd = ref('');
const isSaveId = ref(false);

const isInputIdPswd = computed(() => {
  if (mberId.value.length >= 4 && mberPswd.value.length >= 4) return true;
  else return false;
})

const valid = () => {
  let isValid = true;
  let msg = '';

  if (!mberId.value) {
    msg = '아이디를 입력해주세요.';
    isValid = false;
  }

  if (isValid && !mberPswd.value) {
    msg = '비밀번호를 입력해주세요.';
    isValid = false;
  }

  return {isValid, msg};
}

const lgin_click = async () => {
  try {
    $loading.on();

    const {isValid, msg} = valid();
    if (!isValid) {
      await $alert(msg);
      return false;
    }

    await lgin();
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
}

const emits = defineEmits(['close']);
const lgin = async () => {
    const {data} = await $axios.post('/api/cmmn/user-lgin', {mberId: mberId.value.trim(), mberPswd: mberPswd.value.trim()});

    const {cd, mberSn, mberNm} = data;
    if (cd == '999') {
      await $alert('등록되지 않은 아이디 이거나, 잘못된 비밀번호입니다.');
      return false;
    }

    $mber.set({mberSn, mberNm});
    setSaveId();
    await getFcltyMberNvtnCntByMberSn(mberSn);

    // 과거 세무 신고자료 수집 안내 팝업으로 인해 임시로 로그인 후 새로고침 추가
    location.reload();
}

const getFcltyMberNvtnCntByMberSn = async (mberSn) => {
  const nvtnCnt = await $cmmn.fclty.getFcltyMberNvtnCntByMberSn(mberSn);
  if (nvtnCnt > 0) openMberFcltyNvtnsPopup();
  emits('close');
}

const openMberFcltyNvtnsPopup = () => {
  const popupOpts = {
    header: '시설 초대 내역',
    contentStyle: {
      'width': '650px',
    }
  }

  $popup.show(MberFcltyNvtns, popupOpts);
}


// 아이디 저장
const setSaveId = () => {
  let id = '';
  let days = -1;

  // 14일로 변경
  if (isSaveId.value) {
    id = mberId.value;
    days = 14;
  }

  let todayDate = new Date();
  todayDate.setDate(todayDate.getDate() + days);
  document.cookie = "saveId=" + encodeURIComponent(id) + "; path=/; expires=" + todayDate.toGMTString() + ";"
}

// 저장된 아이디 가져오기
const getSaveId = () => {
  const cookies = document.cookie
          .split('; ')
          .map(cookie => cookie.split('='));

  const matched = cookies.find(([key]) => key === 'saveId');

  const saveMberId = matched ? decodeURIComponent(matched[1]) : null;
  if (saveMberId) {
    isSaveId.value = true;
    mberId.value = saveMberId;
  }
}

const txtIdPswdFind_click = () => {
  const popupOpts = {
    header: '아이디ㆍ비밀번호 찾기',
    contentStyle: { width: '450px' }
  }

  $popup.show(IdPswdFind, popupOpts);
}

onMounted(() => {
  getSaveId();
})

</script>

<style scoped>

</style>
